import SmartOnFhir from './smartonfhir';

export default SmartOnFhir;
